import React from 'react';
import { FormattedMessage } from 'react-intl';

export const AccessLogsByCredentials = ({ row }) => {
  const {
    credentials = {},
    email,
    phoneNumber,
    accessPoint,
    direction,
    ipAddress,
    deviceSerialNumber,
    deviceTime,
    deviceCategory,
  } = row || {};

  const [formattedCredentialsLabel, formattedCredentialsValue] = (credentials.value || '').split(':');

  const showPhoneNumber = credentials.type !== 'Card';
  const serialNumberFallback = credentials.type === 'Bluetooth' || credentials.type === 'Card' ? 'No' : '-';

  const fields = [
    { id: 'email', defaultMessage: 'E-mail', value: email },
    ...(showPhoneNumber ? [{ id: 'phoneNumber', defaultMessage: 'Phone number', value: phoneNumber }] : []),
    { id: 'accessNumber', defaultMessage: 'Access number', value: accessPoint },
    { id: 'direction', defaultMessage: 'Direction', value: direction },
    { id: 'ipAddress', defaultMessage: 'IP address', value: ipAddress },
    { id: 'serialNumber', defaultMessage: 'Serial number', value: deviceSerialNumber, fallback: serialNumberFallback },
    { id: 'deviceTime', defaultMessage: 'Device time', value: deviceTime },
    { id: 'deviceCategory', defaultMessage: 'Device category', value: deviceCategory },
  ];

  return (
    <div>
      {fields.map(({ id, defaultMessage, value, fallback = '-' }) => (
        <p key={id}>
          <strong>
            <FormattedMessage
              id={id}
              defaultMessage={defaultMessage}
            />:
          </strong>{' '}
          {value || fallback}
        </p>
      ))}
      {formattedCredentialsLabel && (
        <p>
          <strong>{formattedCredentialsLabel}:</strong> {formattedCredentialsValue || '-'}
        </p>
      )}
    </div>
  );
};

